import { AfterViewInit, Directive, inject, Injector, OnDestroy, ViewChild } from "@angular/core";

import { noop, ScriptLoaderService, UtilsService } from '@wm/core';

import { FragmentMonitor } from "../util/fragment-monitor";
import { PrefabManager } from "@wms/page-workspace";
import { PageDirective, PrefabContainerComponent } from "@wm/design-runtime";
import { Subject } from "rxjs";
import { startsWith, trim } from "lodash-es";
import { AppRef } from "@wms/design-container";

import { WidgetRef } from '@wm/components-base';
import { BaseVariableService, VARIABLE_CONSTANTS } from "@wms/variables";
import { I18nService } from "@wms/services";


@Directive()
export abstract class BasePrefabComponent extends FragmentMonitor implements AfterViewInit, OnDestroy {
  Widgets: any;
  Actions: any;
  App: AppRef;
  injector: Injector;
  containerWidget: any;
  prefabMngr: PrefabManager;
  displayName: string;
  prefabName: string;
  i18nService: I18nService;
  @ViewChild(PrefabContainerComponent) prefabContainerComponent: PrefabContainerComponent;
  scriptLoaderService: ScriptLoaderService;
  compileContent = false;
  pageDirective: PageDirective;
  // Viewport: Viewport;
  spa: boolean;

  destroy$ = new Subject();
  // override viewInit$ = new Subject();

  private viewParent: any;
  private utilsService: UtilsService;
  private baseVariableService: BaseVariableService;
  abstract evalUserScript(prefabContext: any, appContext: any, utils: any): any;
  abstract getVariables(): any;
  abstract getExpressions(): any;

  onPageContentReady: Function = noop;

  getContainerWidgetInjector() {
    return this.containerWidget.inj || this.containerWidget.injector;
  }

  override init() {
    this.App = inject(AppRef);
    this.utilsService = inject(UtilsService);
    //making the code compatible in both the JIT and AOT modes
    this.containerWidget = inject(WidgetRef);
    this.prefabMngr = inject(PrefabManager);
    this.i18nService = inject(I18nService);
    this.scriptLoaderService = inject(ScriptLoaderService);
    // this.Viewport = inject(Viewport);
    this.baseVariableService = inject(BaseVariableService);

    this.viewParent = this.containerWidget.viewParent;

    if (this.viewParent.registerFragment) {
      this.viewParent.registerFragment();
    }

    if (this.spa) {
      // this.pageDirective = inject(SpaPageDirective);
    } else {
      // this.pageDirective = inject(PageDirective);
    }
    if (this.pageDirective) {
      // this.registerDestroyListener(this.pageDirective.subscribe('attach', data => this.ngOnAttach(data.refreshData)));
      // this.registerDestroyListener(this.pageDirective.subscribe('detach', () => this.ngOnDetach()));
    }

    // register functions for binding evaluation
    // this.registerExpressions();
    // this.initUserScript();

    this.registerWidgets();
    // this.initVariables();
    // this.registerProps();
    this.defineI18nProps();
    super.init();
  }

  get Variables() {
    const projectDetails = this.baseVariableService.projectService.getDetails();
    const prefabName = projectDetails.type === 'PREFAB' ? this.prefabName : VARIABLE_CONSTANTS.PREFAB_PREFIX + this.prefabName;
    return this.baseVariableService.variableInstanceCollection[prefabName];
  }

  registerWidgets() {
    this.Widgets = {};
    this.Widgets = {};this.containerWidget.Widgets = this.Widgets;
  }

  initUserScript(pfScope: any) {
    try {
      this.evalUserScript(pfScope, this.App, this.utilsService);
    } catch (e) {
      console.error(`Error in evaluating prefab (${this.prefabName}) script\n`, e);
    }
  }

  get appLocale() {
    return this.i18nService.appLocale;
  }

  defineI18nProps() {
    // this.appLocale = this.i18nService.appLocale;
  }

  registerProps() {
    this.prefabMngr.loadAppPrefabConfig(this.prefabName)
      .then((config: any) => {

        if (config) {
          this.displayName = config.displayName;
          Object.entries((config.properties || {}))
            .forEach(([key, prop]: [string, any]) => {
              let expr;
              const value = trim(prop.value);

              if (startsWith(value, 'bind:')) {
                expr = value.replace('bind:', '');
              }

              Object.defineProperty(this, key, {
                get: () => this.containerWidget[key],
                set: nv => this.containerWidget.widget[key] = nv
              });

              if (expr) {
                //[Todo-CSP]: expr will be generated with prefab.comp.expr.ts
                // this.registerDestroyListener(
                  // $watch(expr, this, {}, nv => this.containerWidget.widget[key] = nv)
                // );
              }
            });

          Object.entries((config.events || {}))
            .forEach(([key, prop]: [string, any]) => {
              (this as any)[key] = (...args: any[]) => {
                const eventName = key.substr(2).toLowerCase();
                this.containerWidget.invokeEventCallback(eventName, {$event: args[0], $data: args[1]});
              };
            });

          Object.entries((config.methods || {}))
            .forEach(([key, prop]: [string, any]) => {
              this.containerWidget[key] = (...args: any[]) => {
                try {
                  if ((this as any)[key]) {
                    return (this as any)[key].apply(this, args);
                  }
                } catch (e) {
                  console.warn(`error in executing prefab-${this.prefabName} method-${key}`);
                }
              };
            });
        }
        this.containerWidget.setProps(config);
      });
  }

  // initVariables() {
  //   const variablesService = inject(BaseVariablesService);
  //
  //   // get variables and actions instances for the page
  //   const variableCollection = variablesService.register(this.prefabName, this.getVariables(), this);
  //
  //   // create namespace for Variables nad Actions on page/partial, which inherits the Variables and Actions from App instance
  //   this.Variables = {};
  //   this.Actions = {};
  //   this.containerWidget.Variables = this.Variables;
  //   this.containerWidget.Actions = this.Actions;
  //
  //   // assign all the page variables to the pageInstance
  //   Object.entries(variableCollection.Variables).forEach(([name, variable]) => this.Variables[name] = variable);
  //   Object.entries(variableCollection.Actions).forEach(([name, action]) => this.Actions[name] = action);
  //
  //
  //   this.viewInit$.subscribe(noop, noop, () => {
  //     variableCollection.callback(variableCollection.Variables).catch(noop);
  //     variableCollection.callback(variableCollection.Actions);
  //   });
  // }


  onReady() {}

  // user overrides this
  onPropertyChange() {}

  invokeOnReady() {
    // triggering watchers so variables and propertiers watching over an expression are updated
    // $invokeWatchers(true, true);

    this.onReady();
    if (this.viewParent.resolveFragment) {
      this.viewParent.resolveFragment();
    }
    this.containerWidget.invokeEventCallback('load');
  }

  private loadScripts() {
    return new Promise<void>((resolve) => {
      const scriptsRequired = this.prefabContainerComponent.$element.attr('scripts-to-load');
      if (scriptsRequired) {
        this.scriptLoaderService
          .load(...scriptsRequired.split(','))
          .then(resolve);
      } else {
        resolve();
      }
    });
  }

  ngAfterViewInit(): void {
    this.loadScripts().then(() => {
      this.compileContent = true;
      this.registerChangeListeners();
      setTimeout(() => {
        // trigger viewInit$.complete after a timeout so that the widget listeners are ready before Variable xhr call.
        this.viewInit$.complete();
        this.fragmentsLoaded$.subscribe(noop, noop, () => this.invokeOnReady());
      }, 100);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.complete();
  }

  registerChangeListeners() {
    this.containerWidget.registerPropertyChangeListener(this.onPropertyChange);
    this.containerWidget.registerStyleChangeListener(this.onPropertyChange);
  }

  registerDestroyListener(fn: Function) {
    this.destroy$.subscribe(noop, noop, () => fn());
  }
}
